/**
 * HTML Element
 *
 */
import withComponentMarkers from '../../shared/helpers/withComponentMarkers'
import type { SharedHProps } from './H'
import H from './H'

const H3 = ({ size, ...props }: SharedHProps) => (
  <H element="h3" size={size || 'auto'} {...props} />
)

withComponentMarkers(H3, {
  _isHeadingElement: true,
  _supportsSpacingProps: true,
})

export default H3
